document.addEventListener("DOMContentLoaded", function () {
    const addToCartContainer = document.getElementById("add-to-cart-container");
    const tileSelectors = [document.getElementById("tile-1"), document.getElementById("tile-2"), document.getElementById("tile-3")];

    function checkSelections() {
        let allSelected = true;

        tileSelectors.forEach((tile, index) => {
            const personalization = document.getElementById(`personalization-${index + 1}`);
            const zip = document.getElementById(`zip-code-${index + 1}`);
            const party = document.getElementById(`party-${index + 1}`);
            const initial = document.getElementById(`initial-${index + 1}`);
            const family = document.getElementById(`family-name-${index + 1}`);

            if (!tile.value) {
                allSelected = false;
            }

            // Show or hide personalization fields
            if (tile.value === "home-sweet-home-truck") {
                personalization.style.display = "block";
                if (!zip.value || !party.value || !initial.value) allSelected = false;
            } else if (tile.value === "house-tile") {
                personalization.style.display = "block";
                if (!family.value) allSelected = false;
            } else if (tile.value === "initial-tile") {
                personalization.style.display = "block";
                if (!initial.value) allSelected = false;
            } else {
                personalization.style.display = "none";
            }
        });

        // Show Add to Cart button only when all selections are made
        addToCartContainer.style.display = allSelected ? "block" : "none";
    }

    tileSelectors.forEach(tile => tile.addEventListener("change", checkSelections));
    document.querySelectorAll(".personalization-fields input").forEach(input => input.addEventListener("input", checkSelections));

    checkSelections(); // Run check on page load
});
